import Cookies from 'js-cookie';

export const setAuthCookie = (token, expirationDate) => {
	const expiration = new Date(expirationDate);
	Cookies.set('authToken', token, { expires: expiration, sameSite: 'strict' });
};

export const getAuthCookie = () => {
	const token = Cookies.get('authToken');
	if (!token) return 'expired';
	return token;
};

export const removeAuthCookie = () => {
	Cookies.remove('authToken');
};

// Store user role in localStorage for router-level access
export const setUserRole = (role) => {
	if (role) {
		localStorage.setItem('userRole', role);
	}
};

export const getUserRole = () => {
	return localStorage.getItem('userRole') || null;
};

export const removeUserRole = () => {
	localStorage.removeItem('userRole');
};
